<template>
    <div
        class="grid-container"
        :style="{
            height: height + 'px',
              gridTemplateColumns: `repeat(${menuData.length-1}, 1fr)`
}"
    >
        <div
            class="grid-container-item"
            v-for="(v) in menuData.slice(0,5)"
            :key="v.id"
        >

            <flex-col style="height:100%;overflow:hidden">
                <flex-fixed>
                    <flex-row>
                        <flex-fixed style="width:28px;position:relative;height:42px">
                            <img
                                class="item-icon"
                                :src="require('../../assets/menu/'+v.icon+'.svg')"
                            />
                            <img
                                class="item-icon-hover"
                                :src="require('../../assets/menu/'+v.icon+'-hover.svg')"
                            />
                        </flex-fixed>
                        <flex-fill class="title"><a @click="toDetail(v.id, '1')">{{v.title}}</a></flex-fill>
                    </flex-row>
                </flex-fixed>
                <flex-fill>
                    <flex-row class="label-wraper">
                        <a
                            v-for="(x) in v.labelList"
                            :key="x.key"
                            @click="toDetail(v.id, x.key)"
                            :title="x.label"
                        >{{x.label}}</a>
                    </flex-row>
                </flex-fill>
            </flex-col>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        menuData: {
            type: Array,
            default: [],
        },
    },
    methods: {
        toDetail(menuId, labelId) {
            console.log("id: ", menuId);
            this.$router.push({
                path: "/more/",
                query: { menu: menuId, label: labelId },
            });
        },
    },
    computed: {
        height() {
            if (this.menuData.length === 0) return 90;
            const maxlen = Math.max(
                ...this.menuData.map((v) => v.labelList.length)
            );
            const maxline = Math.ceil(maxlen / 2);
            return 90 + 30 * maxline;
        },
    },
};
</script>

<style lang="scss" scoped>
.grid-container {
    display: grid;
    // grid-template-columns: repeat(5, 240px);
    /* gap: 20px 20px; */
    box-shadow: 0px 4px 10px 0px rgba(192, 196, 208, 0.16);
    background-color: #fff;
    transition: 0.2s all ease-out;

    &:not(:hover) {
        height: 142px !important;
    }
    * {
        transition: 0.3s all ease-in;
    }

    .grid-container-item {
        background-color: #fff;
        padding: 0 24px;
        padding-top: 24px;
        padding-bottom: 24px;
        // margin-bottom: 24px;
        position: relative;
        overflow: hidden;

        &::after {
            content: "";
            position: absolute;
            top: 24px;
            bottom: 24px;
            right: 0;
            width: 1px;
            background-color: #f0f0f0;
        }
        &:last-child {
            position: inherit;
        }

        &:hover {
            margin-top: 0px;
            margin-bottom: 0px;
            padding: 24px;
            // background: #fff1d7;
            background: linear-gradient(180deg, #fff1d7 0%, #fff8ea 100%);
            .item-icon {
                opacity: 0;
                // display: none;
            }
            .item-icon-hover {
                opacity: 1;
            }
        }

        .item-icon,
        .item-icon-hover {
            position: absolute;
            margin-right: 8px;
            margin-top: 3px;
            top: 0;
            left: 0;
        }

        .item-icon {
            // box-shadow: 0px 4px 8px 0px rgba(71,  113, 248, 0.5);
        }

        .item-icon-hover {
            opacity: 0;
            // box-shadow: 0px 4px 8px 0px rgba(170,  130, 61, 0.5);
        }

        .title {
            font-size: 18px;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
            line-height: 26px;
            height: 26px;
            margin-bottom: 16px;
            overflow: hidden;
            a {
                display: inline-block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                width: 100%;
            }
        }

        .label-wraper {
            display: flex;
            flex-wrap: wrap;
            color: rgba(0, 0, 0, 0.65);

            a {
                width: 50%;
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                display: inline-block;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin-bottom: 8px;

                &:nth-child(2n)::before {
                    content: "|";
                    margin-right: 8px;
                    color: rgba(0, 0, 0, 0.08);
                }
            }
        }
    }
}
</style>
